<h3 class="common-sub-title">e-moshicom連携アカウント管理</h3>

<dialog-content class="content">

  <table class="common-table v">
    <tbody>
      <tr>
        <th class="common-required">ID/メールアドレス</th>
        <td>
          <div>
            <input type="text" name="id" class="wFull" [formControl]="idFormCtl"/>
          </div>
          <app-validate-error [formCtl]="idFormCtl" [minLength]="1"></app-validate-error>
        </td>
      </tr>
      <tr>
        <th class="common-required">パスワード</th>
        <td>
          <div>
            <input type="password" name="pass" class="wFull" [formControl]="passwordFormCtl"/>
          </div>
          <app-validate-error [formCtl]="passwordFormCtl" [minLength]="1"></app-validate-error>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="login-container">
    <button class="common-btn-submit" (click)="login()">連携する</button>
  </div>

  <div class="separator"></div>

  @if (connections.length === 0) {
    <p>
      連携済みアカウントはありません。
    </p>
  }
  @if (connections.length !== 0) {
    <table class="common-table h moshicom-account-table">
      <colgroup>
      <col class="col1">
      <col class="col2">
    </colgroup>
    <thead>
      <tr>
        <th>連携済みアカウント</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      @for (connection of connections; track connection) {
        <tr>
          <td>
            <a href="{{connection.url}}" target="_blank">{{ connection.name }}</a>
          </td>
          <td>
            <button class="common-btn-important" (click)="delete(connection)">連携解除</button>
          </td>
        </tr>
      }
    </tbody>
  </table>
}


<div class="separator"></div>

<div class="operation-container">
  <button class="common-btn-cancel" (click)="close()">閉じる</button>
</div>

</dialog-content>
